// extracted by mini-css-extract-plugin
export default {"search-this-area__button":"search-this-area__button_o1459aTP"};